import {
  BatteryIcon,
  DiamondIcon,
  HrvIcon,
  TemperatureIcon,
} from '@jouzen/ecom-components';
import type { SVGProps } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import type { PopHighlightsRingTooltipProps } from '../PopHighlightsRingTooltip';

type Icon = (props: SVGProps<SVGSVGElement>) => JSX.Element;

export interface PopHighlightsFeatureData {
  bullets?: MessageKey;
  description: MessageKey;
  Icon: Icon;
  id: string;
  title: MessageKey;
  tooltip?: PopHighlightsRingTooltipProps;
}

const popHighlightsFeatures: PopHighlightsFeatureData[] = [
  {
    bullets: 'pop_highlights_accuracy_bullets',
    description: 'pop_highlights_accuracy_copy',
    Icon: TemperatureIcon as Icon,
    id: 'accuracy',
    title: 'pop_highlights_accuracy_title',
  },
  {
    description: 'pop_highlights_battery_copy',
    Icon: BatteryIcon as Icon,
    id: 'battery',
    title: 'pop_highlights_battery_title',
    tooltip: {
      content: 'pop_highlights_battery_tooltip',
      orientation: {
        x: 'left',
        y: 'top',
      },
      position: {
        x: 4,
        y: 22,
      },
    },
  },
  {
    bullets: 'pop_highlights_materials_bullets',
    description: 'pop_highlights_materials_copy',
    Icon: DiamondIcon as Icon,
    id: 'materials',
    title: 'pop_highlights_materials_title',
    tooltip: {
      content: 'pop_highlights_materials_tooltip',
      orientation: {
        x: 'right',
        y: 'top',
      },
      position: {
        x: 79,
        y: 17,
      },
    },
  },
  {
    bullets: 'pop_highlights_sensors_bullets',
    description: 'pop_highlights_sensors_copy',
    Icon: HrvIcon as Icon,
    id: 'sensors',
    title: 'pop_highlights_sensors_title',
  },
];

export default popHighlightsFeatures;
